import { render } from "./SoftCheckModel.vue?vue&type=template&id=669b17f2"
import script from "./SoftCheckModel.vue?vue&type=script&lang=js"
export * from "./SoftCheckModel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__